import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container _mypage sub_page" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_MyInfo = _resolveComponent("MyInfo")!
  const _component_InquiryList = _resolveComponent("InquiryList")!
  const _component_MyContentsList = _resolveComponent("MyContentsList")!
  const _component_ApplyList = _resolveComponent("ApplyList")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"deco_wrap\"><i class=\"deco_01 _medium blink3\"><img src=\"img/b_icon_03.png\"></i><i class=\"deco_02 _small blink_zoom2\"><img src=\"img/b_icon_02.png\"></i><i class=\"deco_03 _small spin_blink2 D_only\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_04 _small spin1 D_only\"><img src=\"img/b_icon_03.png\"></i><i class=\"deco_06 spin_blink3 _small\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_07 blink_zoom4 _small\"><img src=\"img/b_icon_02.png\"></i><i class=\"deco_character\"><img src=\"img/mypage_icon.png\"></i></div><div class=\"banner_wrap wrap_1120\"><h2>마이페이지</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeType(0))),
              class: _normalizeClass([$setup.state.type === 0 ? 'active' : ''])
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "회원정보수정", -1)
            ]))], 2),
            (!$setup.user.userInfo.isAdmin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeType(1))),
                    class: _normalizeClass([$setup.state.type === 1 ? 'active' : ''])
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("a", { href: "javascript:void(0)" }, "1:1 문의", -1)
                  ]))], 2),
                  _createElementVNode("li", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeType(2))),
                    class: _normalizeClass([$setup.state.type === 2 ? 'active' : ''])
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("a", { href: "javascript:void(0)" }, "내가 쓴 게시글", -1)
                  ]))], 2),
                  _createElementVNode("li", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeType(3))),
                    class: _normalizeClass([$setup.state.type === 3 ? 'active' : ''])
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("a", { href: "javascript:void(0)" }, "신청내역", -1)
                  ]))], 2)
                ], 64))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      ($setup.state.type === 0)
        ? (_openBlock(), _createBlock(_component_MyInfo, { key: 0 }))
        : _createCommentVNode("", true),
      (!$setup.user.userInfo.isAdmin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($setup.state.type === 1)
              ? (_openBlock(), _createBlock(_component_InquiryList, { key: 0 }))
              : ($setup.state.type === 2)
                ? (_openBlock(), _createBlock(_component_MyContentsList, { key: 1 }))
                : ($setup.state.type === 3)
                  ? (_openBlock(), _createBlock(_component_ApplyList, { key: 2 }))
                  : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Footer)
  ], 64))
}